package org.example.project.engineletter

import androidx.compose.runtime.Composable
import org.example.project.engineletter.layouts.SupportLayoutSysDocument
import org.example.project.utils.All

@Composable
fun RenderSupportLetterSys(
    rootElementId: String? = null,
    ticket: All,
    kunde: All?,
    unternehmen: All,
    logoSrc: String,
    manuelleLoesung: String,
    signaturBildSrc: String,
    signaturNameText: String,
    includeLoesungBlock: Boolean = true,
    grussformelText: String = "Mit freundlichen Grüßen",
    closingNameText: String = signaturNameText
) {
    val screenText = ticket.screenKey
    val analyseText = ticket.manuelleFehlerursache
        .ifBlank { ticket.ticketgrund }
        .ifBlank { ticket.loesungsweg }
    val loesungText = ticket.manuelleLoesung
        .ifBlank { manuelleLoesung }
    val supportLines = mutableListOf(
        "Mitarbeiter: ${listOf(ticket.vorname, ticket.nachname).filter { it.isNotBlank() }.joinToString(" ").ifBlank { "-" }}",
        "Screen: ${screenText.ifBlank { "-" }}",
        "",
        "Problembeschreibung:",
        ticket.problembeschreibung.ifBlank { "-" },
        "",
        "Abschlussanalyse:",
        analyseText.ifBlank { "-" }
    )
    if (includeLoesungBlock) {
        supportLines += listOf(
            "",
            "Lösung:",
            loesungText.ifBlank { "-" }
        )
    }

    SupportLayoutSysDocument(
        rootElementId = rootElementId,
        ticket = ticket,
        kunde = kunde,
        unternehmen = unternehmen,

        logoSrc = logoSrc,
        betreffText = ticket.ticketnummer.ifBlank { "SUP-${ticket.id}" },
        briefText = supportLines.joinToString("\n"),
        grussformelText = grussformelText,
        signaturBildSrc = signaturBildSrc,
        signaturNameText = closingNameText
    )
}
